export const convertValueToLocalString = (value: string): string =>
  parseFloat(value).toLocaleString("en");
